import { PRICING } from "@constants/internal-route.constant";
import { ENV } from "config/ENV.config";
import { Link } from "react-router-dom";

/** The slim footer under the signed-out pages (sign-in screens, Home, Pricing). */
const PublicFooter = ({ className = "" }: { className?: string }) => (
  <div className={`small text-body-secondary d-flex flex-wrap justify-content-center column-gap-3 row-gap-1 ${className}`}>
    <span>
      &copy; {new Date().getFullYear()} {ENV.brandName}. All rights reserved.
    </span>
    {ENV.billingEnabled ? (
      <Link to={PRICING} className="link-secondary">
        Pricing
      </Link>
    ) : null}
    {ENV.marketingUrl ? (
      <>
        <a href={`${ENV.marketingUrl}/about-us.php`} className="link-secondary">
          About us
        </a>
        <a href={`${ENV.marketingUrl}/contact.php`} className="link-secondary">
          Contact us
        </a>
      </>
    ) : null}
    <a href={`mailto:${ENV.supportEmail}`} className="link-secondary">
      {ENV.supportEmail}
    </a>
    {/* This install's own support number, from REACT_APP_SUPPORT_PHONE (.env.sky). */}
    {ENV.supportPhone ? (
      <a href={`tel:${ENV.supportPhone.replace(/\s+/g, "")}`} className="link-secondary">
        {ENV.supportPhone}
      </a>
    ) : null}
  </div>
);

export default PublicFooter;
